<template>
  <div class="h-1/2  flex flex-row justify-between ">
    <div class="flex flex-col justify-center space-y-2 mb-2">
      <div class="flex flex-row items-baseline space-x-2">
        <div class="justify-self-start text-2xl  font-semibold " :class="[colorPalette.importantText]">{{data.activeAccounts}} </div>
        <div class="text-lg">active accounts</div>
      </div>
      <div class="flex flex-row items-baseline space-x-2">
        <p class="justify-self-start text-2xl  font-semibold " :class="[colorPalette.importantText]">{{data.registrationsPending}}</p>
        <p class="text-lg">registrations pending</p>
      </div>
    </div>
    <div class="w-1/2 mb-4">
      <pie-chart class="mx-6" v-if="loaded"
                 :source="source"
                 :labels="data.labels"
                 :data="data.data"
                 :colorPalette="colorPalette"></pie-chart>
    </div>
  </div>
  <div class="w-full border-t border-gray-300 mb-4"></div>
  <div  class="flex flex-col ">
    <div class="w-full bg-gray-200 rounded-2xl">
      <div ref="progressBar" class="text-sm font-bold text-lg text-center py-1.5 leading-none rounded-2xl " :class="[colorPalette.progressBarBackground + ' ' + colorPalette.progressBarText]" style="width: 0;">{{percentage}}</div>
    </div>
    <div class="flex flex-row justify-between mx-2 mt-2">
      <div class="flex flex-row items-baseline space-x-3 ">
        <div class="text-2xl  font-semibold " :class="[colorPalette.importantText]">{{ data.activeAccounts }}</div>
        <div>invitations accepted</div>
      </div>
      <div class="flex flex-row items-baseline space-x-3 ">
        <div class="text-2xl  font-semibold " :class="[colorPalette.importantText]">{{ data.invitationsSent }}</div>
        <div>invitations sent</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PieChart from "@/widgetContent/charts/PieChart";
import {defineProps, onMounted, ref} from "vue";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})

let data = ref(Object);
let loaded = ref(false);
let percentage = ref("0%")
let progressBar = ref(null);

onMounted ( async () => {
  let apiData = await apiService.get(props.source);
  data.value = apiData.data;
  loaded.value = true;
  percentage.value =( data.value.activeAccounts / data.value.invitationsSent).toFixed(2)*100 + "%";
  progressBar.value.style.width = percentage.value;
    }
)
</script>

